import { useTranslation } from '@wojtekmaj/react-t';

import { getAccountName } from '@rewardopl/utils/account';

import { Avatar as AvatarElement } from './account_avatar.styles';

import accountAvatarPlaceholder from '../../static/account-avatar-placeholder.svg';

import type { Account } from '@rewardopl/types';

type AccountAvatarProps = {
  account: Account;
  size?: number;
};

export default function AccountAvatar({ account, size = 50 }: AccountAvatarProps) {
  const accountName = getAccountName(account);
  const accountNameString = useTranslation(accountName);

  function onError(
    event: React.SyntheticEvent<HTMLImageElement, Event> & { target: HTMLImageElement },
  ) {
    const { target } = event;
    target.src = accountAvatarPlaceholder;
  }

  return (
    <AvatarElement
      alt={accountNameString}
      height={size}
      onError={onError}
      src={
        account.avatar
          ? `/api/uploads/${account.avatar}?w=${size * devicePixelRatio}`
          : accountAvatarPlaceholder
      }
      width={size}
    />
  );
}
